import resource from '@api/resource';
import store from '../store';

/**
 * Gets the environment assets URL.  This should already be loaded when the site is loaded.
 */
function getAssetsUrl() {
  const env = store.getters['content/environment'];
  return env.IRAPO_ASSETS_URL;
}

/**
 * Gets the specified asset with the key given.  key is really just the relative path
 * from the URL.
 */
function get(key) {
  const url = getAssetsUrl();
  return resource.get(`${url}/${key}`);
}

export default {
  get
};